enum ActionTypes {
    GET_TEAMS_INTEGRATION = "teamsIntegration/getTeamsIntegration",
    SET_TEAMS_INTEGRATION = "teamsIntegration/setTeamsIntegration"
}

export default ActionTypes;
